module.exports = __webpack_public_path__ + "static/img/hotwatera2e452e.png";